import { useFrame } from '@react-three/fiber';
import { useState } from 'react';
import * as THREE from 'three';

/**
 * Determines the visibility of a sign based on its position relative to the camera.
 * @param position The position of the sign.
 * @param camera The camera being used.
 * @param distanceToCamera The distance threshold for visibility.
 * @returns Whether the sign is visible.
 */
export const useSignVisibility = (
  position: THREE.Vector3,
  camera: THREE.Camera,
  distanceToCamera: number,
) => {
  const [isVisible, setIsVisible] = useState(true);

  useFrame(() => {
    if (!position) return;

    const cameraPos = camera.position;
    setIsVisible(position.distanceTo(cameraPos) < distanceToCamera);
  });

  return isVisible;
};
